import myAxios from "@/utils/request";
export default {
  getData() {
    return myAxios.get("/api/achievement/getfpagestatistics");
  }
};
